import { Th } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { Icon } from 'components/atoms'

export const ThCustom = styled(Th)`
    cursor: pointer;
`

export const IconReturn = styled(Icon)`
    position: absolute;
    cursor: pointer;
    z-index: 1100;
    top: 1rem;
    left: 0.5rem;
`
